<template>
  <div>
      <span v-for="e in webhookList"
        :key="e.id"
        :title="JSON.stringify(e)">#{{e.id}} {{e.name}}</span>
  </div>
</template>

<script>
export default {
    name : "WebhookByTriggerId",

    props : ['value'],

    data() {
        return {
            webhookList : []
        };
    },

    mounted() {
        var _this = this;
        sdk.WebhookApi().listByTriggerId({
            triggerId : _this.value
        }).then(res => {
            _this.webhookList = res || [];
        });
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/setting/WebhookByTriggerId.vue